import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import useTokenExpiration from "../src/Components/useTokenExpiration/useTokenExpiration";
import Login from "./view/Login/Login";
import Home from "./view/Home/Home";
import SidebarMenu from "./Components/SidebarMenu/SidebarMenu";
import PrivateRoute from "./Components/PrivateRoute"; // Asegúrate de importar PrivateRoute
import Menuoperaciones from "./Components/Operaciones/Menu/Menu"
import Inbound from "./Components/Operaciones/Inbound/inbound";
import DetallesInbound from "./Components/Operaciones/Inbound/DetalleInboun";
import Planmuestreo from "./Components/Operaciones/Planmuestreo/Planmuestreo"
import Parametrizacion from "./Components/Parametrizacion/Menu"
import Permisos from "./Components/Parametrizacion/Permiso/Permiso"
import Ubicaciones from "./Components/Parametrizacion/Ubicaciones/CrearUbicaciones";
import Lugares from "./Components/Parametrizacion/Lugar/crearLugar";
import Factores from "./Components/Parametrizacion/Factorcarga/PostFactor";
import Dispositivos from "./Components/Parametrizacion/Dispositivo/Dispositivo";
import Tiposbolsa from "./Components/Parametrizacion/Tipobolsa/tipoBolsa";
import Clientes from "./Components/Parametrizacion/Cliente/gestionCliente";
import Usuarios from "./Components/Parametrizacion/Usuario/gestionUsuario";
import Menuregistrycontrol from "./Components/Registroycontrol/Menu/Menu";
import Referencia from "./Components/Registroycontrol/Referencia/nuevaRefereencia";
import Material from "./Components/Parametrizacion/Material/rmaterial";
import DetallesInboundParalelo from "./Components/Operaciones/Inbound/Paralelos/DetallesInboudParalelo";
import Informes from "./Components/Informes/Menu/Menuinformes";
import Reporteopera from "./Components/Informes/Operaciones/Reporteopera";
import FirmarPDF from "./Components/Registroycontrol/Firmacertificado/Firmarcert";
import VerificarPDF from "./Components/Registroycontrol/Verificarcert/Verificarcert";
import ReportBuil from "./Components/ReportBuilder/ReportBuilder";
import submenuope from "./Components/Informes/Operaciones/Submenu/submenuope";
import menuanalisis from "./Components/Analisis/Menu/Menu" 
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const location = useLocation();
  useTokenExpiration(); // 👈 activa la detección de expiración

  // Si estás en login, no renderices el layout completo
  if (location.pathname === "/login") {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  return (
    <div className="App" style={{ display: "flex", minHeight: "100vh", backgroundColor: "#0a0e14" }}>
      {/* Sidebar visible en todas las páginas excepto login */}
      <SidebarMenu
        onLogout={() => alert("Cerrando sesión...")}
        onChangePassword={() => alert("Cambiando contraseña...")}
      />

      {/* Contenido principal */}
      <div style={{ marginLeft: "30px", padding: "12px", width: "90%" }}>
        <Routes>
          <Route path="/home" element={<PrivateRoute element={Home} />} />
          <Route path="/operaciones" element={<PrivateRoute element={Menuoperaciones} />} />
          <Route path="/inbound" element={<PrivateRoute element={Inbound} />} />
          <Route path="/planmuestreo" element={<PrivateRoute element={Planmuestreo} />} />
          <Route path="/detallesinbound/:Idref" element={<PrivateRoute element={DetallesInbound} />} />
          <Route path="/parametrizacion" element={<PrivateRoute element={Parametrizacion} />} />
          <Route path="/permisos" element={<PrivateRoute element={Permisos} />} />
          <Route path="/ubicaciones" element={<PrivateRoute element={Ubicaciones} />} />
          <Route path="/lugares" element={<PrivateRoute element={Lugares} />} />
          <Route path="/factores" element={<PrivateRoute element={Factores} />} />
          <Route path="/dispositivos" element={<PrivateRoute element={Dispositivos} />} />
          <Route path="/bolsa" element={<PrivateRoute element={Tiposbolsa} />} />
          <Route path="/clientes" element={<PrivateRoute element={Clientes} />} />
          <Route path="/usuarios" element={<PrivateRoute element={Usuarios} />} />
          <Route path="/registroycontrol" element={<PrivateRoute element={Menuregistrycontrol} />} />
          <Route path="/referencia" element={<PrivateRoute element={Referencia} />} />
          <Route path="/material" element={<PrivateRoute element={Material} />} />
          <Route path="/detallesinboundparalelo/:Idref" element={<PrivateRoute element={DetallesInboundParalelo} />} />
          <Route path="/informes" element={<PrivateRoute element={Informes} />} />
          <Route path="/reporteope" element={<PrivateRoute element={Reporteopera} />} />
          <Route path="/firmacert" element={<PrivateRoute element={FirmarPDF} />} />
          <Route path="/verifacioncert" element={<PrivateRoute element={VerificarPDF} />} />
          <Route path="/informe" element={<PrivateRoute element={ReportBuil} />} />
          <Route path="/informesope" element={<PrivateRoute element={submenuope} />} />
          <Route path="/analisis" element={<PrivateRoute element={menuanalisis} />} />
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </div>
    </div>
  );
}


export default App;
